var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NodeViewWrapper',{staticClass:"mention",attrs:{"as":"span","data-mention-participant-id":_vm.dataMentionParticipantId,"data-mention-id":_vm.dataMentionId}},[_vm._v(_vm._s(_vm.mappedValue))])}
var staticRenderFns = []

export { render, staticRenderFns }